import colors from './colors'

export const DEFAULT_XY = 1
export const DEFAULT_COLOR = 'rgba(0,0,0,0.1)'

const shadowColor = (color = DEFAULT_COLOR) => {
  if (isNaN(color)) {
    return color
  }

  return `rgba(0,0,0,${color})`
}

export const box = ({x = DEFAULT_XY, y = DEFAULT_XY, blur = 1, color = DEFAULT_COLOR} = {}) => ({
  boxShadow: `${x}px ${y}px ${blur}px ${shadowColor(color)}`,
})

export const boxTop = ({
  x = DEFAULT_XY,
  y = -2,
  blur = DEFAULT_XY,
  color = DEFAULT_COLOR,
} = {}) => box({x, y, blur, color})

export const boxBottom = ({
  x = 0,
  y = DEFAULT_XY,
  blur = DEFAULT_XY,
  color = DEFAULT_COLOR,
} = {}) => box({x, y, blur, color})

export const border = ({ width = 1, color = colors.grey() } = {}) => {
  const dropShadow =
    `drop-shadow(${width}px ${width}px 0 ${color}) ` +
    `drop-shadow(-${width}px -${width}px 0 ${color}) ` +
    `drop-shadow(${width}px -${width}px 0 ${color}) ` +
    `drop-shadow(-${width}px ${width}px 0 ${color})`

  return {
    filter: dropShadow,
    WebkitFilter: dropShadow,
  }
}

export default {
  box,
  boxTop,
  boxBottom,
  border,
}
